import { render } from "./SelectCustom.vue?vue&type=template&id=0bdbf314&scoped=true"
import script from "./SelectCustom.vue?vue&type=script&lang=js"
export * from "./SelectCustom.vue?vue&type=script&lang=js"

import "./SelectCustom.vue?vue&type=style&index=0&id=0bdbf314&scoped=true&lang=css"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdbf314"]])

export default __exports__